// app/frontend/controllers/agents_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "searchInput"];

  connect() {
    // Listen for successful form submissions
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this));
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      // Flash a success message or update UI
      this.showSuccessMessage();
    }
  }

  showSuccessMessage() {
    // Add a temporary success indicator
    const flash = document.getElementById("flash");
    if (flash) {
      setTimeout(() => {
        flash.innerHTML = "";
      }, 5000);
    }
  }

  // Real-time search functionality (optional enhancement)
  search() {
    if (!this.hasSearchInputTarget) return;

    const searchTerm = this.searchInputTarget.value.toLowerCase();
    const rows = this.element.querySelectorAll("tbody tr[data-agent-id]");

    rows.forEach(row => {
      const text = row.textContent.toLowerCase();
      if (text.includes(searchTerm)) {
        row.classList.remove("hidden");
      } else {
        row.classList.add("hidden");
      }
    });
  }

  // Toggle agent status (for future use with availability status)
  async toggleStatus(event) {
    const button = event.currentTarget;
    const agentId = button.dataset.agentId;
    const newStatus = button.dataset.status;

    try {
      const response = await fetch(`/agents/${agentId}/toggle_status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]").content
        },
        body: JSON.stringify({ status: newStatus })
      });

      if (!response.ok) {
        throw new Error("Failed to update status");
      }

      // Turbo Stream will handle the UI update
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update agent status");
    }
  }

  // Refresh the agents list
  refresh() {
    // Trigger a Turbo Frame refresh
    const frame = document.getElementById("agents_list");
    if (frame) {
      frame.reload();
    }
  }
}
